import { ActivateAccountRequest } from '../api/requests/activate-account.request';
import { AuthApiService } from '../api/services/auth-api.service';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SignUpAsClientForm } from '../models/sign-up-as-client-form';
import { SignUpAsClientResponse } from '../api/responses/sign-up-as-client.response';
import { SignUpAsCompanyForm } from '../models/sign-up-as-company-form';
import { SignUpAsClientRequest } from '../api/requests/sign-up-as-client.request';
import { SignUpAsCompanyRequest } from '../api/requests/sign-up-as-company.request';

@Injectable({
  providedIn: 'root',
})
export class SignUpService {
  private readonly authApi = inject(AuthApiService);

  public signUpAsClient(
    form: SignUpAsClientForm,
  ): Observable<SignUpAsClientResponse> {
    return this.authApi.signUpAsClient(
      new SignUpAsClientRequest(
        form.username,
        form.password,
        form.email,
        form.firstName,
        form.lastName,
        form.newsletter,
      ),
    );
  }

  public signUpAsCompany(
    form: SignUpAsCompanyForm,
  ): Observable<SignUpAsClientResponse> {
    return this.authApi.signUpAsCompany(
      new SignUpAsCompanyRequest(
        form.username,
        form.password,
        form.email,
        form.companyName,
        form.nip,
        form.newsletter,
      ),
    );
  }

  public activate(token: string): Observable<void> {
    return this.authApi.activate(new ActivateAccountRequest(token));
  }
}
